import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import '../../includes/custom/css/header.css';
import '../../includes/custom/css/custom-bootstrap.css';
import '../../includes/custom/css/navigation.css';
import SHSAALOGO from '../../includes/img/logo.png';
import LogoutIcon from '../../includes/img/svg/logout.svg';
import { SHSAA_STORES } from './../../utils/constants';

class StoreHeader extends Component {

    render() {
        return (
            <Navbar className='header-nav'>
                <Navbar.Brand>
                    <div className='navFlex'>
                        <img src={SHSAALOGO} className="header-logo" alt='shsaaa-logo' />
                        <p className="header-appname">{SHSAA_STORES}</p>
                    </div>
                </Navbar.Brand>
                <Navbar.Collapse>
                    <Nav className="mr-auto">
                    </Nav>
                    {this.props.isStoreAuthenticated && <Nav className='headerRightNav'>
                        <Nav.Link onClick={() => this.props.logoutStore()} className="logoutLabel"> Logout </Nav.Link><img className="logoutButton" src={LogoutIcon} alt='logout' />
                    </Nav>}
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default StoreHeader;